export enum ThemePreference {
  Light = 1,
  Dark = 2,
}
